// extracted by mini-css-extract-plugin
module.exports =  {"news":"NewsListItem-KKfH__news","header-image":"NewsListItem-E3dl__header-image","title":"NewsListItem-sRkw__title"};